export default __webpack_public_path__ + "static/media/iotControls.992ed76b.jpg";